<div class="content-area">
  <table class="table table-vertical" *ngIf="version">
    <caption>
      Xdb info
    </caption>
    <tbody>
      <tr>
        <th class="left">Commit date</th>
        <td class="left">{{dateHelper.utils.formatByString(version.commitdate, 'yyyy-MM-dd') }}</td>
      </tr>
      <tr>
        <th class="left">Build date</th>
        <td class="left">{{dateHelper.utils.formatByString(version.builddate, 'yyyy-MM-dd') }}</td>
      </tr>
      <tr>
        <th class="left">Commit hash</th>
        <td class="left">{{version.commithash}}</td>
      </tr>
      <tr>
        <th class="left">Branch</th>
        <td class="left">{{version.branch}}</td>
      </tr>
    </tbody>
  </table>

</div>
